<template>
    <div class="ctrmain">
        <div class="leftbox">
            <div :class="menu == item.name ? 'menuitem med' : 'menuitem'" v-for="(item, i) in menulist" :key="i"
                    @click="menuchange(item.name)">
                   
                    <div class="icon"><img :src="menu == item.name ? item.iconed : item.icon" /></div>
                    <div class="name">{{ item.name }}</div>
                </div>
        </div>
        <div class="rightbox" v-loading="loading" element-loading-text="正在下控">
            <div class="imgbox">
                 <div class="statustip" v-if="menulist.filter(item => item.name == menu)[0].ctlstatus"><div class="point"></div>远程控制中</div>
                 <div class="statustip st2" v-else><div class="point p2"></div>本地控制中</div>
                <div class="title"><span>{{menulist.filter(item => item.name == menu)[0].content}}</span></div>
                <img :src="menulist.filter(item => item.name == menu)[0].bg" alt="" srcset="">
            </div>
            <div class="tip" v-if="menu == '灌溉'">{{menulist.filter(item => item.name == menu)[0].status ? '设备正在运行' : '设备未运行'}}</div>
            <div :class="menulist.filter(item => item.name == menu)[0].ctlstatus ? 'toggle-container' : 'toggle-container noclick'" v-if="menu == '灌溉'" style="justify-content: center;">
                <label class="switch">
                    <input type="checkbox" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, menulist.filter(item => item.name == menu)[0].status ? 0: 1)" :checked="menulist.filter(item => item.name == menu)[0].status">
                    <span class="slider"></span>
                </label>
            </div>
            <!-- <div class="toggle-container"  v-if="menu == '灌溉'" style="justify-content: center;">
                <el-switch
                    @change="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, menulist.filter(item => item.name == menu)[0].status ? 0: 1)"
                    v-model="menulist.filter(item => item.name == menu)[0].status"
                    :disabled="!menulist.filter(item => item.name == menu)[0].ctlstatus"
                    active-color="#67C23A"
                    inactive-color="#f472b6">
                </el-switch>
            </div> -->
            <div class="toggle-container" style="margin-top: 20px;" v-else>
                <template v-if="menu == '防雨'">
                    <el-button type="success" :disabled="isrun" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, 0)" round>展开</el-button>
                    <el-button type="primary" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, -1)" round>暂停</el-button>
                    <el-button type="danger" :disabled="isrun" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, 1)" round>收拢</el-button>
                </template>
                <template v-else>
                    <el-button type="success" :disabled="isrun" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, 1)" round>展开</el-button>
                    <el-button type="primary" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, -1)" round>暂停</el-button>
                    <el-button type="danger" :disabled="isrun" @click="setsbstatussd(menulist.filter(item => item.name == menu)[0].id, 0)" round>收拢</el-button>
                </template>
            </div>
        </div>

        <div class="setbtnbox" v-if="menu == '灌溉'">
            <div class="setbtn" @click="sbdrawer = true"><i class="el-icon-setting"></i></div>
        </div>
        <el-drawer
            title="可操控设备列表"
            :visible.sync="sbdrawer"
            direction="btt"
            size="200px"
            :before-close="handleClose">
            <div class="sbitembox">
                滴灌电磁阀（{{sb1status == '1' ? '已打开' : '已关闭'}}）：
                <el-switch
                    v-model="sb1status"
                    active-color="#13ce66"
                    inactive-color="#f472b6"
                    active-value="1"
                    inactive-value="2">
                </el-switch>
            </div>
            <div class="sbitembox">
                喷灌电磁阀（{{sb1status == '2' ? '已打开' : '已关闭'}}）：
                <el-switch
                    v-model="sb1status"
                    active-color="#13ce66"
                    inactive-color="#f472b6"
                    active-value="2"
                    inactive-value="1">
                </el-switch>
            </div>
        </el-drawer>
    </div>

</template>

<script>
import {getwarlist, getsblist, setsbstatus, getsbstatusbyid, setsbstatusbyid, getsbonlinestatus} from '@/api/bot'
export default {
    name: 'index',
    components: {  },
    data() {
        return {
            sbdrawer: false,
            sb1status: '1',
            menu: '灌溉',
            menulist: [{
                icon: require('../../assets/img/znt/ctr/gg.png'),
                iconed: require('../../assets/img/znt/ctr/gged.png'),
                bg: require('../../assets/img/znt/ctr/c1.png'),
                name: '灌溉',
                ctlstatus: false,
                status: false,
                content: '水泵及管道电磁阀'
            }, {
                icon: require('../../assets/img/znt/ctr/bw.png'),
                iconed: require('../../assets/img/znt/ctr/bwed.png'),
                bg: require('../../assets/img/znt/ctr/c3.png'),
                name: '控温',
                status: true,
                ctlstatus: false,
                content: '遮阳帘'
            }, {
               
                icon: require('../../assets/img/znt/ctr/kw.png'),
                iconed: require('../../assets/img/znt/ctr/kwed.png'),
                bg: require('../../assets/img/znt/ctr/c2.png'),
                name: '保温',
                status: true,
                ctlstatus: false,
                content: '侧卷膜'
            }, {
                icon: require('../../assets/img/znt/ctr/fy.png'),
                iconed: require('../../assets/img/znt/ctr/fyed.png'),
                bg: require('../../assets/img/znt/ctr/c4.png'),
                name: '防雨',
                status: true,
                ctlstatus: false,
                content: '顶窗卷膜'
                }],
            loading: false,
            isrun: false,
            reslistkey: {
                '1#2#卷膜机远程状态': '保温',
                '3#4#卷膜机远程状态': '防雨',
                '灌溉机远程状态': '灌溉',
                '遮阳帘远程状态': '控温'
            },
        }
    },
    computed: {

    },
    mounted() {
        this.getlist()
    },
    methods: {
        getonlinelist() {
            getsbonlinestatus().then(res => {
                Object.keys(res).forEach(item => {
                    const newitem = this.menulist.filter(litem => this.reslistkey[item] == litem.name)[0]
                    console.log(newitem)
                    newitem.ctlstatus = res[item] == 'True'
                })
            })
             console.log('设备是否在线', this.menulist)
        },
        menuchange(e) {
            this.menu = e
            setTimeout(() => {
                this.getstatus(this.menulist.filter(item => item.name == e)[0].id)
            }, 200);
        },
        getlist() {
            getsblist().then(res => {
                console.log('设备列表', res)
                this.menulist.forEach(item => {
                    const newitem = res.data.filter(s => s.scene.includes(item.name))[0]
                    console.log(newitem)
                    item.time = newitem.time || 0;
                    item.status = newitem.status;
                    item.statusTime = newitem.statusTime;
                    item.id = newitem.id
                })
                setTimeout(() => {
                    this.getstatus(this.menulist[0].id)
                    this.getonlinelist()
                }, 200);
            })
        },
        getstatus(id) {
            getsbstatusbyid(`id=${id}`).then(res => {
                console.log('当前设备状态', res)
                this.menulist.filter(item => item.id == id)[0].status = res.data.status
            })
        },
        setsbstatussd(id, status) {
            this.isrun = true
            const item = this.menulist.filter(item => item.id == id)[0]
            this.menulist.filter(item => item.id == id)[0].status = !item.status
            this.loading = true
            let newstatus = (status == undefined ? (item.status ? 0 : 1) : status)
            // console.log(newstatus)
            // return;
            if (status == -1) {
                this.isrun = false
            }
            if (this.menu == '灌溉') {
                this.$message.success(`即将${status== 0 ? '关闭' : '打开'}${item.content}`)
            } else if (this.menu == '防雨') {
               
                this.$message.success(`即将${status== 0 ? '展开' : status== 1 ? '收拢' : '暂停'}${item.content}`)
            } else {
                this.$message.success(`即将${status== 0 ? '收拢' : status== 1 ? '展开' : '暂停'}${item.content}`)
            }
            
            setsbstatusbyid(`id=${id}&status=${newstatus}&type=${this.sb1status}`).then(res => {
                if (res.code == 200) {
                    if (this.menu == '灌溉') {
                        this.$message.success(`${this.sb1status== 1 ? '滴灌灌溉中..' : '喷灌灌溉中..'}`)
                    } else if (this.menu == '防雨') {
                        this.$message.success(`顶部卷膜${status== 0 ? '展开中..' : status== 1 ? '收拢中..' : '已暂停'}`)
                    } else {
                        this.$message.success(`${item.content}${status== 0 ? '收拢中..' : status== 1 ? '展开中..' : '已暂停'}`)
                    }
                    this.$message.success(`${item.content}设备请求已发送`)
                    this.loading = false
                } else {
                    this.loading = false
                    item.status = !item.status
                    this.$message.error(res.message)
                }
            })
            const time = id == 1 ? 480 : id == 2 ? 360 : 120
            setTimeout(() => {
                this.isrun = false
            }, time * 1000);
        }
    }
}




</script>

<style scoped lang="less">
.ctrmain {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 20px 0;
    display: flex;

    .leftbox{
        width: 50px;
            background: #e2ebf5c2;
            border-radius: 10px;
            border: 1px solid #ffffff90;
            height: calc(100% - 60px);
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;

            .menuitem {
                width: 100%;
                padding-top: 10px;
                color: #8e9b5f;
                margin-bottom: 20px;

                .icon {
                    width: 100%;
                    text-align: center;

                    img {
                        width: 20px;
                    }
                }

                .name {
                    margin-top: 5px;
                    width: 100%;
                    text-align: center;
                    font-size: 14px;

                }
            }

            .med {
                color: #D94E6B;
            }
    }


    .rightbox{
        width: calc(100% - 70px);
        margin-left: 20px;
        background-color: #FFFFFF60;
        border-radius: 20px;
        padding: 20px;

        .imgbox{
            width: 100%;
            position: relative;
            display: flex;
            flex-wrap: wrap;
            .statustip{
                width: 100%;
                justify-content: flex-end;
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                color: #45b26d;
                .point{
                    width: 10px;
                    height: 10px;
                    background-color: #45b26d;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .p2{
                    background-color: #545454;
                }
            }
            .st2{
                color: #545454;
            }
            .title{
                width: 100%;
                position: absolute;
                top: 50px;
                left: 0;
                font-size: 16px;
                text-align: center;
                span{
                    padding: 10px 20px;
                    background-color: #ffffff90;
                     border-radius: 8px;
                }
            }
            img{
                width: 100%;
            }
        }
        .tip{
            width: 100%;
            text-align: center;
            margin: 20px 0;
            color: #00000090;
            font-size: 14px;

        }
        .toggle-container {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .noclick{
            pointer-events: none;
            opacity: 0.5; /* 可选：为了视觉上更明显，可以降低透明度 */
            cursor: not-allowed; /* 可选：设置光标为禁止图标 */
        }
        
        .status-text {
            font-size: 18px;
            font-weight: bold;
        }
        
        .switch {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 25px;
        
        }
        
        .switch input {
            opacity: 0;
            width: 0;
            height: 0;
        }
        
        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #f472b6; /* 收拢状态颜色 */
            transition: .3s;
            border-radius: 34px;
        }
        
        .slider:before {
            position: absolute;
            content: "";
            height: 18px;
            width: 18px;
            left: 4px;
            bottom: 4px;
            background-color: white;
            transition: .3s;
            border-radius: 50%;
        }
        
        input:checked + .slider {
            background-color: #4ade80; /* 打开状态颜色 */
        }
        
        input:checked + .slider:before {
            transform: translateX(23px);
        }
        
        #status {
            padding: 12px;
            border-radius: 8px;
            color: white;
            font-size: 18px;
            font-weight: bold;
            background-color: #f472b6; /* 收拢状态背景 */
        }
        
        input:checked ~ #status {
            background-color: #4ade80; /* 打开状态背景 */
        }
        
        input:checked ~ .toggle-container .off {
            color: #999; /* 打开时OFF文本变灰 */
        }
        
        input:checked ~ .toggle-container .on {
            color: #4ade80; /* 打开时ON文本变绿 */
        }
        
        .off {
            color: #f472b6; /* 收拢时OFF文本变粉 */
        }
        
        .on {
            color: #999; /* 收拢时ON文本变灰 */
        }
    }
    .setbtnbox{
        position: fixed;
        bottom: 20px;
        right: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 40px;
        .setbtn{
            font-size: 30px;
            color: #00000090;
        }
        .msgbtn{
            margin-top: 20px;
            img{
                width: 40px;
            }
        }
    }
    /deep/ .el-drawer__header{
        font-size: 18px;
    }
    /deep/ .el-drawer__header{
        margin-bottom: 10px;
    }
    .infoitem{
        background-color: #1D280010;
        margin: 10px 20px;
        padding: 10px;
        border-radius: 8px;
        color: #00000080;
        .time{
            display: flex;
            align-content: center;
            .point{
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #f3000082;
                margin-right: 10px;
            }
        }
        .content{
            font-size: 14px;
            margin-top: 10px;
            line-height: 20px;
        }
    }
    .sbitembox{
        background-color: #1D280010;
        margin: 10px 20px;
        padding: 10px;
        border-radius: 8px;
        color: #00000080;
        font-size: 14px;
    }
}
</style>
